// extracted by mini-css-extract-plugin
export default {"iconDefault":"Debt_iconDefault__zN6Qx"};